import React from 'react';

import { withEventScope } from '@repo/event-processor';

import { NavigationItem } from 'components/HeadMenu/types';
import { FlexRow } from 'styles/layouts';

import NavigationItemComponent from './NavigationItemComponent';

const NavigationItems: React.FC<{ items: NavigationItem[] }> = ({ items }) => {
  return (
    <nav>
      <FlexRow as="ul">
        {items.map((nav) => (
          <NavigationItemComponent key={nav.label} navigationItem={nav} />
        ))}
      </FlexRow>
    </nav>
  );
};

export default withEventScope(NavigationItems, { module: 'desktopNavigation' });
